<template src="./login.html"></template>

<script>
import mixin from "@/mixin/styleMixin.js";

export default {
  mixins: [mixin],

  data() {
    return {
      showPwd: false,
      cred: {
        Utente: "",
        Password: "",
        Ricorda: false
      },
      disabilitaBtn: false,

      style: {
        maxWidth: "300px",
        maxHeight: "560px",
        marginLeft: "auto",
        marginRight: "auto"
      }
    };
  },

  methods: {
    async submit() {
      window.scrollTo(0, 0); // Scroll to top (serve sul mobile per vedere eventuali messaggi)

      // Validazione
      if (this.$refs.formLogin.validate() == false) {
        return;
      }

      // Disabilito bottone login
      this.disabilitaBtn = true;

      try {
        // Login
        await this.$store.dispatch("auth/login", this.cred);

        // Vado alla pagina riservata
        this.$router.push({ path: "/" });
      } catch (error) {
        this.$toast.warning(this.$i2kFunctions.getErrorMsg(error));
      }

      // Abilito bottone login
      this.disabilitaBtn = false;

      return false;
    }
  }
};
</script>



